import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const EnService = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "40weeks later";
    return () => {
      document.documentElement.lang = "ko";
      document.title = "열달후에";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">40weeks later</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          EN
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li className="selected">
              <em>EN</em>
            </li>
            <li>
              <Link to="/policy/ja/service">JP</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Terms of Use</PolicyTitle>

      <PolicySectionTitle>
        &lt;Chapter 1&gt; Welcome! Fill in the precious moments with ‘40weeks
        later’
      </PolicySectionTitle>
      <PolicyArticleTitle>Article 1. Purpose</PolicyArticleTitle>
      <PolicyText>
        Thank you for using the Services provided by Connect-i Co.,Ltd.
        (hereinafter, the "Company'). The Company has established “40weeks later
        Terms and Conditions" there to (hereinafter, the " Terms of Use") to
        provide a more diverse and convenient Internet and mobile Services. THIS
        Terms of Use prescribes general provisions about the rights, duties and
        responsibilities, terms of use, and procedures required in use of the
        Service. The Company appreciates your taking time to read it carefully.
      </PolicyText>

      <PolicyArticleTitle>
        Article 2. Effect and Modification of Terms and Conditions
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① This Terms and Conditions shall be posted in the relevant pages of
          ‘40weeks later’ Website or app Services, and shall enter into force
          between the Parties that have consented hereto.
        </li>
        <li>
          ② The Company, if deemed necessary, can modify this Terms and
          Conditions within the scope not contravening the relevant laws and
          regulations. In such case, the amended contents shall be announced or
          notified by the Company at least fifteen (15) days prior to the
          effective date. If the foregoing modification unavoidably operates to
          your disadvantage, the Company shall individually transmit the notice
          thereon, at least thirty (30) days prior to the effective date, to
          your email address via email or to your mobile phone number or text
          messages (unless you have any email address, other electronic methods
          including electronic notice or pop-up message in the Service shall be
          applied.)
        </li>
        <li>
          ③ Unless you explicitly refuse to accept the aforementioned
          modification within a set period, from the date of announcement or
          notification hereby to seven (7) days after the effective date, the
          Company shall presume your consent thereto. Unless you agree to the
          revised Terms and Conditions, you may terminate the Service Agreement
          at any time.
        </li>
        <li>
          ④ Members may choose to terminate the use contract by expressing their
          objection to the changed terms and conditions. Termination of the use
          contract is possible through withdrawal of members from the service.
        </li>
      </PolicyList>

      <PolicyArticleTitle>Article 3. Additional Terms</PolicyArticleTitle>
      <PolicyText>
        Any matters that are not prescribed in this Terms and Conditions shall
        be subject to the relevant laws and regulations, Terms of Service of
        Individual Services, and Operation Policies and Rules set forth by the
        Company (hereinafter, the "Guiding Principles").
      </PolicyText>
      <PolicyArticleTitle>Article 4. Definition of Terms</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① The Terms herein shall be defined as follows:
          <ul>
            <li>
              1) "Account" refers to the Company's Login Account Policy that
              allows users to manage with a single login account and password,
              verification of user identity, modification of his/her personal
              information, and sign-up and withdrawal for membership in the
              Individual Services provided by the Company or its Partners.
            </li>
            <li>
              2) "Member" refers to a person who uses ‘40weeks later’ service,
              after having agreed to this Terms and Conditions in the Individual
              Services associated with ‘40weeks later’ application service.
            </li>
            <li>
              3) "Account Information" refers to any required or optional
              information set by the Company. Account Information means any
              member information that can be checked, modified and managed in
              the account settings page.
            </li>
          </ul>
        </li>
      </PolicyList>

      <PolicySectionTitle>
        &lt;Chapter 2&gt; Service Agreement
      </PolicySectionTitle>
      <PolicyArticleTitle>Article 5. Formation of Agreement</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① If the user reads these Terms and Conditions, presses the "Agree"
          button, or checks "OK", etc., they are deemed to have agreed to these
          Terms and Conditions.
        </li>
        <li>
          ② Membership registration for the use of the company's service shall
          be made by entering mandatory matters including membership ID (email
          account) according to the membership registration method determined by
          the company, and pressing the "Register" or "OK" buttons. However, if
          the company deems it necessary, it may require members to submit
          separate documents.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        Article 6. Limitation of Account Use
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① Membership registration is established by the user's application for
          membership registration and the company's approval of membership
          registration. In principle, the company automatically approves the
          membership when the applicant faithfully enters the essentials and
          completes the application. However, in the following cases, the
          company may withhold consent or cancel consent until the reasons are
          resolved.
          <ul>
            <li>
              1) Where it is deemed that he/she has subscribed to the service by
              using personal information such as the name or email address of
              another person
            </li>
            <li>
              2) If you don't have realistic leeway for service-provided storage
            </li>
            <li>
              3) If the technical part of the service delivery is deemed to be
              problematic
            </li>
            <li>
              4) Other cases deemed financially and technically necessary by the
              company
            </li>
            <li>
              5) Where a person who has received a suspension of service use
              from the company voluntarily cancels the service use contract and
              applies for re-registration
            </li>
            <li>
              6) If it violates other relevant laws and regulations or violates
              the standards set by the company, such as detailed guidelines
            </li>
          </ul>
        </li>
        <li>
          ② If a member is found to have subscribed to the service in violation
          of the above conditions, the company may immediately suspend the
          member's use of the service or remove the account.
        </li>
      </PolicyList>

      <PolicySectionTitle>
        &lt;Chapter 3&gt; Use of the service
      </PolicySectionTitle>
      <PolicyArticleTitle>
        Article 7. Providing a wide range of services
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① You can use the service immediately after the company approves the
          service after signing up for membership. Members are free to use the
          service whenever they want.
        </li>
        <li>
          ② However, some sub-services can only be used if you agree to the
          terms and conditions. You can use the service if the conditions are
          met after you enter the necessary additional information or complete
          the authentication process set by the company, such as e-mail address
          approval or self-authentication.
        </li>
        <li>
          ③ The company can provide the updated version needed for the service
          for better service. Updates include the addition of critical features
          or the removal of unnecessary features. Please update us continuously
          so that we can get better service.
        </li>
        <li>
          ④ To provide better service, we can display various information within
          the service, such as announcements, messages, and other advertisements
          related to the use of the service, or send it directly to the contacts
          registered in your account information. However, the company does not
          send advertising e-mails, push messages, or text messages for
          commercial purposes that the members did not agree to receive.
        </li>
        <li>
          ⑤ If you find any problems such as system errors while using the
          service, please contact the customer center at any time. (customer
          center : after10month@connect-i.co.kr)
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        Article 8. Disruption and termination of services
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① The Company exerts every effort in providing the Service 24/7/365.
          If a case falls under any of the following subparagraphs, all or part
          of the Service shall be restricted or suspended by the Company.
          <ul>
            <li>
              1) Regular or provisional check for equipment maintenance of
              Service
            </li>
            <li>
              2) Service disruption due to blackout, equipment failure, or
              traffic overload
            </li>
            <li>
              3) Any case that the Company can no longer maintain Service due to
              changes in circumstance including termination of Partnership
              Agreement, the government order/restriction, changes in the
              Service/Member policies etc.
            </li>
            <li>
              4) Natural disaster, national emergency, or other force majeure
              events
            </li>
          </ul>
        </li>
        <li>
          ② Suspension of Service that is due to any of the foregoing reasons
          shall be notified or announced in the method prescribed in Article 14.
          Repeated logins and/or additional consent from users may be required
          when using Services in order to modify Services or policies
          seamlessly. However, prior notifications and announcements cannot be
          provided if the Service is suspended for reasons the Company is unable
          to predict or control (ex. Disc, server or system failure that is not
          due to the Company's negligence). However, the Company shall still
          make its utmost effort to immediately restore the Service once the
          cause is identified. If Service restoration is delayed for more than
          two (2) hours, such delay shall be alerted through Services' Notice
          and Customer Support Notice sections.
        </li>
      </PolicyList>

      <PolicyArticleTitle>Article 9. Management of Account</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① Account shall be used only by its holder, and any access by other
          person must be banned. The Member shall manage his/her password in
          person to allow no one to appropriate his/her Account. The Company may
          require both password and additional verification to prevent abuse of
          Account by other person. In case of the foregoing appropriation,
          please report it via the Customer Center.
          (after10month@connect-i.co.kr) The Company exerts its utmost effort to
          inform how to prevent such appropriation.
        </li>
        <li>
          ② The Members can view and modify their information in the page of
          Account Settings. However, you may not be able to change some
          information including Account, phone number, unique device identifiers
          and other user identification information require to provide and
          manage Account Service. In case of such modification, an additional
          user identification may be required. If you wish to update any
          information you entered at the time of sign-up, you can modify it in
          person or contact us via email or Customer Service.
        </li>
        <li>
          ③ The Company takes no responsibility for any loss attributable to
          your negligence in timely updating Account Information.
        </li>
        <li>
          ④ When using SNS login such as Google or Apple login, it is impossible
          to find a password within the app service because it is logged in
          through the linked token provided by the SNS.
        </li>
      </PolicyList>

      <PolicyArticleTitle>Article 10. management of posts</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① If a member's post contains content that violates related laws such
          as the Copyright Act, the right holder may request the company to stop
          or delete the post in accordance with the procedures set by the
          relevant laws and regulations, and the company takes action in
          accordance with the relevant laws and regulations. The relevant laws
          may be applied differently depending on the laws of each country.
        </li>
        <li>
          ② The company may take temporary action or delete the post in
          accordance with the relevant laws and regulations if there is a reason
          for the infringement of rights or other violations of the company's
          policies and related laws, even if there is no request from the right
          holder.
        </li>
        <li>
          ③ Detailed procedures related to the above shall be in accordance with
          the reporting procedures set by the company within the scope
          prescribed by the relevant laws and regulations.
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        Article 11. Attribution of rights and use of works
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① Members may post content (hereinafter referred to as "posts") within
          the service, such as photos, writings, information, videos, or
          opinions or suggestions about the company, and intellectual property
          rights, including copyrights, of course, will continue to be held by
          the members who posted them.
        </li>
        <li>
          ② Posts created by members may also be exposed to search results,
          customized content areas, and related promotions. To the extent
          necessary for such exposure, some modifications, replications, edits,
          and publications may be made. In this case, the company complies with
          the copyright law regulations, and members may take measures such as
          deleting the post through the customer center at any time.
        </li>
        <li>
          ③ The company may delete or refuse to post a member's post without
          notice if it is deemed to be in violation of relevant laws or
          regulations, a post that encourages discrimination, a post that is
          plastered, advertised, promotional, spammed, transferred or traded
          accounts, or a post impersonating another person. However, the company
          is not obligated to review all content, so if someone violates the
          rights of members, you can report it or get help through the customer
          center.{" "}
        </li>
      </PolicyList>

      <PolicySectionTitle>
        &lt;Chapter 4&gt; Obligation of Contracting Parties
      </PolicySectionTitle>
      <PolicyArticleTitle>Article 12. Member Obligations</PolicyArticleTitle>
      <PolicyList>
        <li>
          ① The Members must perform none of the following activities in use of
          the Service. The company may restrict or suspend members' use of the
          service in the event of a reason falling under each subparagraph.
          <ul>
            <li>
              1) Enter false fact while applying or modifying the Service Use;
              appropriate or unjustifiably use other Member's Account and
              Password; use other's name; or conduct SMS verification without
              consent of a registered person
            </li>
            <li>
              2) Copy, alter, distribute, sell, transfer, lend, secure or allow
              others to use the Service or part of software thereof without the
              Company's consent; and/or copy, disassemble, imitate or transform
              the Service including reverse-engineering of software or any
              attempt to extract source code
            </li>
            <li>3) Defame or injure other's reputation</li>
            <li>
              4) Upload lewd materials on the bulletin board and/or connect
              (link) harmful sites
            </li>
            <li>
              5) Violate other rights of the Company or a third party including
              copyright
            </li>
            <li>
              6) Posting false facts about the company or a third party within
              the service
            </li>
            <li>
              7) Disseminate to others any information, sentence, figure, or
              voice against public order and/or good morals and manners
            </li>
            <li>
              8) Register or circulate computer viruses to cause malfunction of
              equipment, and/or destroy and disrupt information related to the
              Service
            </li>
            <li>
              9) Transmit any information, in bad faith, that can interfere or
              impede a stable Service operation, or any commercial information
              or Spam Mails against recipient's explicit refusal of reception
            </li>
            <li>
              10) Personate a false identity of other person and/or misrepresent
              the relationship with other person
            </li>
            <li>
              11) Collect, store and/or disclose other Member's personal
              information
            </li>
            <li>
              12) Circulate false information to provide oneself or others with
              proprietary benefits, or to damage others
            </li>
            <li>
              13) Gambling or gambling with property or engaging in speculative
              acts
            </li>
            <li>
              14) Circulate any information to arrange prostitution or mediate
              lewd acts
            </li>
            <li>
              15) Interfere other's daily life by having utterance, sound,
              writing or video clip that arouses shame, revulsion or fear
              continuously reached to the aforementioned other person
            </li>
            <li>
              16) Transmit or publish any information (including computer
              program) prohibited by the relevant laws and regulations
            </li>
            <li>
              17) Upload a post, or transmit email or message by disguising or
              personating any officer or administrator of the Company or
              Partners, or appropriating other's name
            </li>
            <li>
              18) Stalking, abusive language, false or malicious reporting
              abuse, etc. that interfere with the use of other members' services
            </li>
            <li>19) Other Illegal Act</li>
          </ul>
        </li>
        <li>
          ② Members shall neither transfer nor grant their rights to use and
          legal status hereby, nor impignorate the foregoing rights and status.
        </li>
        <li>
          ③ If you fail to abide by relevant laws and regulations, all Terms and
          Conditions and/or Policies of the Company, your contravention may be
          investigated, use of the Service may be temporarily or continuously
          suspended, and re-subscription may be restricted by the Company. If
          you adversely affect the provision of Services or severely interfere
          with the stable operation of Services by causing malfunction of
          equipment or by destroying or creating disorder in the system, the
          Company may restrict you from using your account. However, you can
          appeal through Customer Service if you are dissatisfied with the
          imposed restriction.
        </li>
        <li>
          ④ Members can refer to Operation Policy for any matters prescribed
          herein and/or other details about use of the Service.
        </li>
      </PolicyList>
      <PolicyArticleTitle>
        Article 13. Protection of Personal Information
      </PolicyArticleTitle>
      <PolicyText>
        The primary task of the Company is to securely process the Member's
        personal information. Such information shall be used to provide a
        seamless Service only within purpose and scope agreed between the
        Parties hereto. Unless the Members have made a separate consent, or
        except as otherwise prescribed in the relevant laws and regulations, the
        Company must not provide the Member's personal information, which the
        Members can rest assured. The Members can find which efforts the Company
        exerts to securely process their personal information in the Privacy
        Policy.
      </PolicyText>

      <PolicyArticleTitle>
        Article 14. Notification and Announcement to the Members
      </PolicyArticleTitle>
      <PolicyText>
        Communication with the Members is most valued by the Company. The
        Members can visit Customer Center and raise their opinions at any time.
        Notification for all Members shall come into force by being posted in
        the Service Notification for no less than seven (7) days. Any
        notification that may gravely affect your conditions shall be
        individually sent to your registered email address via email, or to your
        registered mobile phone number text message. (Unless mobile phone number
        has been registered, other electronic methods including electronic note
        or pop-up message in the Service will be applied.)
      </PolicyText>

      <PolicySectionTitle>
        &lt;Chapter 5&gt; Termination of the Service
      </PolicySectionTitle>
      <PolicyArticleTitle>
        Article 15. Termination of the Service
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① If a member withdraws from the membership, the service usage
          contract will also be automatically terminated.
        </li>
        <li>
          ② The Members can apply for the termination of the Service Agreement
          at any time in use of the menu provided in the Services. The Company
          will take actions accordingly in a swift manner as prescribed under
          the relevant laws and regulations.
        </li>
        <li>
          ③ When the service usage contract is terminated, all data, such as
          records stored in the member's diary, will be deleted, except for
          holding the member's schedule information in accordance with relevant
          laws and privacy policies.
        </li>
        <li>
          ④ However, services that share information with other members, such as
          Mom’s Talk and Reviews, are not automatically deleted upon withdrawal
          because posts written by members are posted by other members or other
          sharing features, or because members add comments to other members'
          posts.
        </li>
        <li>
          ⑤ Posts not deleted by members pursuant to the preceding paragraph
          will remain unremoved to the extent necessary for the normal use of
          other members' services. Therefore, the posts and comments will not be
          deleted, so please delete them before applying for withdrawal.
          However, even if the post remains, all information of the withdrawing
          members such as nicknames is deleted and is not exposed.
        </li>
        <li>
          ⑥ If you leave an SNS account linked to the service while using the
          service through SNS login such as Google and Apple ID, the SNS-linked
          token will be deleted immediately, making the service unavailable, and
          the service use contract will be automatically terminated.
        </li>
        <li>⑦ Data deleted upon withdrawal can no longer be recovered.</li>
        <li>
          ⑧ Even if the service use contract is terminated, you can apply for
          the conclusion of the service use contract through membership
          registration again.
        </li>
        <li>
          ⑨ However, if a member cancels the service contract and applies for a
          new service contract due to failure to comply with relevant laws,
          these terms and conditions, and detailed guidelines, the service
          subscription may be limited or rejected for a certain period of time.
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        Article 16. Indemnification for Damage
      </PolicyArticleTitle>
      <PolicyList>
        <li>
          ① With regard to the Service, the Company must not assure or guarantee
          any specific matters that are not prescribed in this Terms and
          Conditions within the scope permitted under the relevant laws and
          regulations. The Company shall provide no warranty on credibility and
          accuracy of information, data and fact posted in the Service in a way
          that the Contents Provider (CP) offer or the Member write, and shall
          take no responsibility for any loss occurred without the Company's
          negligence.
        </li>
        <li>
          ② The Company will compensate for any loss caused by its negligence
          under this Terms and Conditions and the relevant laws and regulations;
          provided, however, that the Company shall take no responsibility for
          any loss occurred without its negligence as prescribed in the
          following subparagraphs. Furthermore, the Company shall take no
          liability for indirect, particular, consequential, disciplinary and
          punitive loss.
          <ul>
            <li>
              1) Any loss occurred in an uncontrollable state including natural
              disaster or equivalent force majeure
            </li>
            <li>2) Service error due to reasons attributable to the Members</li>
            <li>
              3) Personal loss arising from access to or use of the Service
            </li>
            <li>
              4) Any loss originated from illegal access to or use of the
              Company's Server by a third party
            </li>
            <li>
              5) Any loss originated from impeded transmission to or from the
              Company's Server by a third party
            </li>
            <li>
              6) Any loss originated from transmission or spread of malware by a
              third party
            </li>
            <li>
              7) Any loss arising from use of the Service by a third party
              including damage or defamation caused by omission, deletion,
              destruction, etc. of transmitted data
            </li>
            <li>
              8) Any other loss arising from acts of the Company that are not
              intentional or negligent
            </li>
          </ul>
        </li>
        <li>
          ③ The company does not support responsibility for damages, and the
          company does not support responsibility for damages caused by service,
          and other services obtained through services.
        </li>
      </PolicyList>
      <PolicyText>
        The company has no obligation to intervene in dispute between members or
        members and third party interactions between members and third parties
        and third party interactions.
      </PolicyText>

      <PolicyArticleTitle>Article 17. Dispute Settlement</PolicyArticleTitle>
      <PolicyText>
        This Terms and Conditions or the Service shall be stipulated and
        executed under the laws and regulations of the Republic of Korea. In
        case of any disputes arising out of or related to use of the Service
        between the Parties concerned, the Company shall faithfully consult with
        the other Party hereto to resolve such issues. Unless the foregoing
        conflicts are settled, the Company may file a lawsuit to a competent
        court under the Civil Procedure Act.
      </PolicyText>
      <PolicyText>Notification Date: Oct 20, 2023</PolicyText>
      <PolicyText>Enforcement Date: Oct 20, 2023</PolicyText>
    </PolicyContainer>
  );
};

export default EnService;
